import { Link } from "react-router-dom";
import { ArrowRight, UtensilsCrossed, ChefHat, Scissors, Sparkles, ShoppingBag, Wrench, BedDouble, KeyRound, Hammer, Building2, Slice } from "lucide-react";
import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import { CtaWhatsApp } from "../components/Cta";
import { Reveal } from "../components/motion";
import { METIERS } from "../data/metiers";

export const METIER_ICONS = {
  utensils: UtensilsCrossed,
  chef: ChefHat,
  scissors: Scissors,
  razor: Slice,
  sparkles: Sparkles,
  bag: ShoppingBag,
  wrench: Wrench,
  bed: BedDouble,
  key: KeyRound,
  hammer: Hammer,
  building: Building2,
};

export default function Solutions() {
  return (
    <>
      <Seo
        title="Solutions par métier"
        description="Cartes digitales premium par secteur : restaurants, coiffeurs, instituts, boutiques, garages, hôtels, immobilier, artisans, entreprises. À partir de 40 € TTC."
        path="/solutions"
      />
      <PageHero
        dark
        eyebrow="Solutions par métier"
        titleLines={["Chaque métier a son geste.", "Chaque geste ouvre un monde."]}
        description="Découvrez comment une carte digitale Noveocard s'adapte à votre secteur : cas d'usage concrets, bénéfices mesurables et exemples réels d'utilisation."
      />

      <section className="bg-brume py-16 sm:py-24">
        <div className="container-nv grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {METIERS.map((m, i) => {
            const Icon = METIER_ICONS[m.icon] || Sparkles;
            return (
              <Reveal key={m.slug} delay={(i % 3) * 0.08} className="h-full">
                <Link
                  to={`/solutions/${m.slug}`}
                  data-testid={`solution-card-${m.slug}`}
                  className="group flex h-full flex-col rounded-3xl border border-nuit-900/10 bg-white p-7 transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_50px_-24px_rgba(7,26,45,0.35)]"
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-nuit-900 text-electric-300 transition-colors duration-500 group-hover:bg-electric group-hover:text-white">
                    <Icon className="h-5 w-5" />
                  </span>
                  <h2 className="mt-5 font-display text-xl font-bold text-nuit-900">{m.name}</h2>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-steel">{m.intro}</p>
                  <span className="mt-5 inline-flex items-center gap-2 font-display text-sm font-semibold text-electric">
                    Découvrir la solution
                    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
                  </span>
                </Link>
              </Reveal>
            );
          })}
        </div>

        <div className="container-nv mt-16 flex flex-col items-center gap-3 text-center">
          <p className="font-display text-2xl font-bold text-nuit-900 sm:text-3xl">
            Votre secteur n'est pas listé ?
          </p>
          <p className="max-w-xl text-steel">
            La carte Noveocard s'adapte à toutes les activités : cafés, bars, photographes, coachs,
            indépendants… Parlez-nous de votre projet.
          </p>
          <CtaWhatsApp
            label="Nous contacter sur WhatsApp"
            message="Bonjour Noveocard, mon activité n'est pas listée sur votre page Solutions. Je souhaite une carte digitale personnalisée."
            showResponseTime
            testid="solutions-cta-whatsapp"
          />
        </div>
      </section>
    </>
  );
}
